(function () {
  function ensureProductFormsInitialized() {
    if (!window.theme || typeof theme.initProductForm !== 'function' || !window.jQuery) {
      return;
    }

    var forms = document.querySelectorAll('.product-form');

    for (var i = 0; i < forms.length; i++) {
      var $form = window.jQuery(forms[i]);

      if ($form.data('themeErrorGuardInit')) {
        continue;
      }

      try {
        theme.initProductForm($form);
        $form.data('themeErrorGuardInit', true);
      } catch (err) {
        if (window.console && console.error) {
          console.error('Guard: failed to initialise product form', err);
        }
      }
    }
  }

  function registerMissingSections() {
    if (!window.theme || !theme.Sections || typeof theme.Sections.register !== 'function') {
      return;
    }

    var sectionMap = [
      ['slideshow', theme.SlideshowSection],
      ['header', theme.HeaderSection],
      ['footer', theme.FooterSection],
      ['cart-drawer', theme.CartDrawerSection],
      ['tiled-images', theme.TiledImagesSection],
      ['collection-template', theme.CollectionTemplateSection],
      ['product-template', theme.ProductTemplateSection],
      ['blog-template', theme.BlogTemplateSection],
      ['cart-template', theme.CartTemplateSection],
      ['collection-listing', theme.CollectionListingSection],
      ['featured-collection', theme.FeaturedCollectionSection],
      ['featured-collections', theme.FeaturedCollectionsSection],
      ['search-template', theme.SearchTemplateSection]
    ];

    if (typeof theme.Sections.init === 'function' && !theme.Sections._errorGuardInited) {
      try {
        theme.Sections.init();
      } catch (e) {}
      theme.Sections._errorGuardInited = true;
    }

    for (var i = 0; i < sectionMap.length; i++) {
      var type = sectionMap[i][0];
      var section = sectionMap[i][1];

      if (!section) {
        continue;
      }

      if (typeof theme.Sections._sectionAlreadyRegistered === 'function' && theme.Sections._sectionAlreadyRegistered(type)) {
        continue;
      }

      try {
        theme.Sections.register(type, section);
      } catch (err) {
        if (window.console && console.error) {
          console.error('Section failed to register, continuing with remaining sections:', type, err);
        }
      }
    }
  }

  function whenReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  // Run immediately (not deferred): the product-form markup above this
  // script tag is already present in the DOM even though the document
  // hasn't finished parsing yet. This has to happen now, synchronously,
  // before later inline/script-tag code (e.g. the product customizer,
  // which looks for the already-built swatch markup to attach its upload
  // widget to) runs - otherwise it attaches its markup in the wrong place.
  ensureProductFormsInitialized();

  whenReady(function () {
    registerMissingSections();
    ensureProductFormsInitialized();
  });
})();
